/**
 * Överenskommelse om evakueringslägenhet vid renovering — composition.
 *
 * Connected under a bostadshyresavtal (same lease, same parties). Tenant(s)
 * and the landlord's representative sign; the besittningsskydd waiver for
 * the evacuation apartment is a mandatory bilaga.
 */
import { COMPOSITION_SCHEMA, COMPOSITION_VERSION } from '@hyranai/regta-document-ir';
const TITLE = 'Överenskommelse om evakueringslägenhet vid renovering';
const FORM_NUMBER = 'Formulär R-09';
const KEY = 'evakuering';
const PREAMBLE = 'Hyresvärden och hyresgästen kommer överens om att hyresgästen tillfälligt bor i en evakueringslägenhet under den tid som renoveringsarbetet av den ordinarie lägenheten pågår.';
export const evakueringV1 = (values = {}) => ({
    schema: COMPOSITION_SCHEMA,
    version: COMPOSITION_VERSION,
    documentKey: KEY,
    documentVersion: 'v1',
    title: TITLE,
    locale: 'sv-SE',
    meta: {
        category: 'Ombyggnad och ändring',
        shortTitle: 'Evakueringsavtal',
        formNumber: FORM_NUMBER,
        signingMode: 'digital',
        signingPlacementAnchors: 'per-party-label',
        status: 'active',
        preamble: PREAMBLE,
        description: 'Tillfälligt tilläggsavtal mellan hyresvärd och hyresgäst som reglerar hyresgästens vistelse i en evakueringslägenhet under tiden som den ordinarie lägenheten renoveras.',
        numberStyle: 'paragraph',
        partySlots: [
            { id: 'lessor', label: 'Hyresvärd', signingLabel: 'Förvaltare', role: 'lessor', ordinal: 0, required: true, signs: true },
            { id: 'lessee_primary', label: 'Hyresgäst (primär)', signingLabel: 'Hyresgäst 1', role: 'lessee', ordinal: 0, required: true, signs: true },
            {
                id: 'lessee_co',
                label: 'Medhyresgäst',
                signingLabel: 'Eventuell hyresgäst 2',
                role: 'lessee',
                ordinal: 1,
                signs: true,
                help: 'Valfritt — lägg till om kontraktet har två hyresgäster.',
            },
        ],
        propertySlots: [{ id: 'property', label: 'Fastighet (ordinarie lägenhet)', multi: false, required: true }],
        connectedTo: ['bostadshyra'],
        inheritFromParent: {
            parties: 'by-role-ordinal',
            property: true,
            values: [
                { key: 'apartment_official_number', fromParentKey: 'property_official_apt_no' },
                { key: 'apartment_monthly_rent', fromParentKey: 'rent_amount' },
            ],
        },
        titleSuffix: { key: 'apartment_official_number', prefix: 'lgh' },
        attachmentSlots: [
            {
                id: 'possession_waiver_annex',
                label: 'Avstående från besittningsskydd – evakueringslägenhet',
                required: true,
            },
        ],
    },
    values,
    blocks: [
        { instanceId: 'letterhead', blockRef: 'common.letterhead@v1', slot: 'letterhead', input: { title: TITLE, form_number: FORM_NUMBER } },
        { instanceId: 'footer', blockRef: 'common.page-footer@v1', slot: 'footer', input: { form_number: FORM_NUMBER } },
        { instanceId: 'preamble', blockRef: 'common.preamble@v1', input: { text: PREAMBLE } },
        { instanceId: 'parter-och-fastighet', blockRef: `${KEY}.parter-och-fastighet@v1`, input: {} },
        { instanceId: 'bakgrund', blockRef: `${KEY}.bakgrund@v1`, input: {} },
        { instanceId: 'ordinarie-och-evakueringslagenhet', blockRef: `${KEY}.ordinarie-och-evakueringslagenhet@v1`, input: {} },
        { instanceId: 'hyra-under-evakueringen', blockRef: `${KEY}.hyra-under-evakueringen@v1`, input: {} },
        { instanceId: 'hyresgastens-ataganden', blockRef: `${KEY}.hyresgastens-ataganden@v1`, input: {} },
        { instanceId: 'var-radd-om-evakueringslagenheten', blockRef: `${KEY}.var-radd-om-evakueringslagenheten@v1`, input: {} },
        { instanceId: 'underskrift', blockRef: `${KEY}.underskrift@v1`, input: {} },
    ],
});
//# sourceMappingURL=evakuering.js.map